import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { appInitProvider } from "@app/services/AppInit.service";
import { MoreModule } from "@app/pages/more/more.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AppHttpInterceptor } from "@app/util/app-http-interceptor";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { windowProvider, WindowToken } from "@app/util/window.token";
import { AppRoutingModule } from "@app/app-routing.module";
import { FormsModule } from "@angular/forms";
import { PipesModule } from "@app/pipes/pipes.module";
import { SharedComponentModule } from "@app/components/shared.component.module";
import { MaterialModule } from "@app/components/material.module";
import { DirectivesModule } from "@app/components/directives.module";
import { ComponentsModule } from "@app/components/components.module";
import { DialogModule } from "@app/components/dialog.module";
import { ServicesModule } from "@app/services/services.module";
import { StoresModule } from "@app/services/stores/stores.module";
import { AppComponent } from "@app/app.component";
import { Tools } from "@app/util/tools";

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        MoreModule,
        StoresModule,
        PipesModule,
        SharedComponentModule,
        MaterialModule,
        DirectivesModule,
        ComponentsModule,
        DialogModule,
        ServicesModule,
    ],
    declarations: [AppComponent],
    providers: [
        appInitProvider,
        { provide: WindowToken, useFactory: windowProvider },
        { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
        Tools,
    ],
    exports: [],
    schemas: [],
    bootstrap: [AppComponent]
})

export class AppModule {}

